import type { LegalDoc } from '../types/content';

export const legalDocs: LegalDoc[] = [
  {
    slug: 'refund-policy',
    title: 'Refund Policy',
    updated: 'October 2026',
    sections: [
      { heading: 'Rescheduling', body: 'You may reschedule a group class at no charge with at least 48 hours’ notice by calling (702) 375-5900 or replying to your confirmation email.' },
      { heading: 'Cancellations', body: 'Cancellations made at least 72 hours before class receive a full refund minus processing fees. Cancellations inside 72 hours receive a credit toward a future class.' },
      { heading: 'No-shows', body: 'Students who do not attend without notice forfeit tuition. Range fees and rentals are paid on site and are not charged for missed classes.' },
      { heading: 'Packages & gift certificates', body: 'Packages and gift certificates are non-refundable but may be transferred. Packages apply to group courses, not private sessions.' },
      { heading: 'Class changes', body: 'If HPP cancels or reschedules a class, you may choose a full refund or transfer to another date.' },
    ],
  },
  {
    slug: 'privacy-policy',
    title: 'Privacy Policy',
    updated: 'October 2026',
    sections: [
      { heading: 'Information we collect', body: 'We collect the contact and registration details you provide when booking, signing up for our newsletter or sending an inquiry.' },
      { heading: 'How we use it', body: 'We use your information to manage registrations, issue certificates, send class reminders and, if you opt in, share news and training updates.' },
      { heading: 'Sharing', body: 'We do not sell your information. We share it only with service providers that help us run our business, or when required by law.' },
      { heading: 'Your choices', body: 'You can unsubscribe from emails at any time and request access to or deletion of your information by contacting us.' },
    ],
  },
  {
    slug: 'terms',
    title: 'Terms of Service',
    updated: 'October 2026',
    sections: [
      { heading: 'Safety', body: 'All students must follow instructor direction and range safety rules at all times. Instructors may remove any student from a class for unsafe behavior without refund.' },
      { heading: 'Eligibility', body: 'Students must meet the legal requirements for each course. CCW applicants are responsible for meeting their sheriff’s eligibility requirements.' },
      { heading: 'Not legal advice', body: 'Course content and information on this website are educational and do not constitute legal advice. Consult an attorney for legal questions.' },
      { heading: 'Liability', body: 'Firearms training carries inherent risk. Students sign a waiver before participating in live-fire activities.' },
    ],
  },
];
